import styled from 'styled-components';

export const Canvas = styled.svg`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const CanvasContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  animation: fadein2 5s linear;
  animation-delay: 5s;
  animation-fill-mode: both;
  opacity: 0;
  @keyframes fadein2{
    to{
      opacity: 1;
    }
  }
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-55%);
`;

export default Wrapper;

